import Accounting from './Accounting.container';

export default Accounting;
